// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@media (max-width: 767px) {\n#bar-chart,\n  #table-chart {\n    display: none;\n}\n}\n@media (min-width: 768px) {\n#bar-chart,\n  #table-chart {\n    display: block;\n}\n#widget .flex-wrap {\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n}\n#widget .w-full {\n    width: 25%;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
